if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('modalOpen', () => {
          setTimeout(() => {
            this.initializeSwiper();
          }, 100);
        });

        // Listen for variant changes
        document.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]') && this.hasAttribute('open')) {
            this.handleVariantChange();
          }
        });

        // Observe Shopify's dynamic updates
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && 
                mutation.attributeName === 'checked' && 
                this.hasAttribute('open')) {
              this.handleVariantChange();
            }
          });
        });

        const variantInputs = document.querySelectorAll('input[type="radio"]');
        variantInputs.forEach(input => {
          observer.observe(input, { attributes: true });
        });
      }

      handleVariantChange() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        setTimeout(() => {
          this.updateVisibleSlides();
          this.initializeSwiper();
        }, 100);
      }

      updateVisibleSlides() {
        const selectedVariants = Array.from(
          document.querySelectorAll('input[type="radio"]:checked')
        )
          .map((input) => input.value.trim().toLowerCase())
          .filter(Boolean);

        const slides = this.querySelectorAll('.cstm-zoom-img, .swiper-slide');
        slides.forEach((slide) => {
          const altValue = (slide.getAttribute('data-media-alt-main') || '').trim();
          const altValues = altValue
            .split(',')
            .map((value) => value.trim().toLowerCase())
            .filter(Boolean);

          const shouldShow =
            selectedVariants.length === 0 ||
            altValues.length === 0 ||
            altValues.some((value) =>
              selectedVariants.some(
                (selectedVariant) =>
                  value === selectedVariant ||
                  value.includes(selectedVariant) ||
                  selectedVariant.includes(value),
              ),
            );

          slide.style.display = shouldShow ? 'block' : 'none';
        });
      }
      
      hide() {
        super.hide();
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      show(opener) {
        const activeGallery = document.querySelector('media-gallery');
        const activeMediaId =
          opener?.dataset?.mediaId ||
          activeGallery?.getActiveMediaId?.() ||
          this.openedBy?.dataset?.mediaId;

        if (activeMediaId && opener && !opener.dataset.mediaId) {
          opener.dataset.mediaId = activeMediaId;
        }

        this.openedBy = opener || this.openedBy;

        super.show(opener || this.openedBy);
        setTimeout(() => {
          this.updateVisibleSlides();
          this.initializeSwiper(activeMediaId);
        }, 100);
      }

      initializeSwiper(activeMediaId = this.openedBy?.dataset?.mediaId) {
        if (!window.Swiper) return;
        
        const swiperContainer = this.querySelector('.cstm-zoom-img-new');
        if (!swiperContainer || this.swiper) return;

        // Initialize Swiper
        this.swiper = new window.Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            init: (swiper) => {
              // Find and show the active slide
              const resolvedMediaId = activeMediaId || this.openedBy?.getAttribute('data-media-id') || document.querySelector('media-gallery')?.getActiveMediaId?.();
              if (resolvedMediaId) {
                const activeSlideIndex = Array.from(swiper.slides).findIndex(slide => {
                  const mediaElement = slide.querySelector('[data-media-id]');
                  return mediaElement && mediaElement.getAttribute('data-media-id') === resolvedMediaId;
                });
                if (activeSlideIndex !== -1) {
                  swiper.slideTo(activeSlideIndex, 0);
                }
              }

              // Show navigation only if there are multiple visible slides
              const visibleSlides = Array.from(swiper.slides).filter(slide => 
                window.getComputedStyle(slide).display !== 'none'
              );
              const navButtons = swiperContainer.querySelectorAll('.swiper-button-next, .swiper-button-prev');
              navButtons.forEach(button => {
                button.style.display = visibleSlides.length > 1 ? 'flex' : 'none';
              });
            }
          }
        });

        // Add event listeners for navigation buttons
        const navButtons = swiperContainer.querySelectorAll('.swiper-button-next, .swiper-button-prev');
        navButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            if (button.classList.contains('swiper-button-next')) {
              this.swiper.slideNext();
            } else if (button.classList.contains('swiper-button-prev')) {
              this.swiper.slidePrev();
            }
          });
        });
      }
    }
  );
}
